import React, { useEffect } from 'react';
import { useCreativeChatStore } from '../stores/creativeChatStore';
import ConversationList from '../components/CreativeChat/ConversationList';
import ChatArea from '../components/CreativeChat/ChatArea';

const CreativeChatPage: React.FC = () => {
  const {
    conversations,
    activeConversationId,
    loadingConversations,
    loadConversations,
    createConversation,
    selectConversation,
    renameConversation,
    deleteConversation,
  } = useCreativeChatStore();

  useEffect(() => {
    loadConversations();
  }, [loadConversations]);

  return (
    <div className="flex h-full bg-bg-page">
      <ConversationList
        conversations={conversations}
        activeConversationId={activeConversationId}
        loading={loadingConversations}
        onSelect={selectConversation}
        onCreate={() => createConversation()}
        onRename={renameConversation}
        onDelete={deleteConversation}
      />
      <ChatArea />
    </div>
  );
};

export default CreativeChatPage;
